import React, { useCallback, useContext } from 'react'
import { NavLink } from 'react-router-dom'
import { Hugeicon } from '../../../icons/Hugeicon'
import { IconGlyph } from '../../../icons/IconGlyph'
import { CurrentUserContext } from '../../../providers/CurrentUserContext'
import Routes from '../../../startup/routes'
import LogoutLink from '../users/LogoutLink'

type UserSidebarProps = {
  onLinkClick?(...args: unknown[]): unknown
}

const UserSidebar: React.FC<UserSidebarProps> = ({ onLinkClick }) => {
  const { currentUser } = useContext(CurrentUserContext)

  const renderYourStories = useCallback(() => {
    const canSubmitStories = currentUser?.isAuthor
    if (!canSubmitStories) return null

    return (
      <li>
        <NavLink to={Routes.yourStories()} className="link" onClick={onLinkClick}>
          <IconGlyph name="megaphone" color="blue" />
          <span className="link-text"> Your Stories</span>
        </NavLink>
      </li>
    )
  }, [currentUser, onLinkClick])

  const renderTopMenu = useCallback(() => {
    return (
      <ul>
        <li>
          <NavLink to={Routes.dashWelcome()} className="link" onClick={onLinkClick}>
            <img className="hgi -kite" src="/img/kite-green.svg" alt="" />
            <span className="link-text"> Welcome</span>
          </NavLink>
        </li>
        <li>
          <NavLink to={Routes.profile()} className="link" onClick={onLinkClick}>
            <IconGlyph name="user" color="silver" />
            <span className="link-text"> Account</span>
          </NavLink>
        </li>
      </ul>
    )
  }, [onLinkClick])

  return (
    <div className="dash-nav-block">
      <div className="dash-nav-subgroup">{renderTopMenu()}</div>

      <div className="dash-nav-subgroup">
        <h4 className="dash-nav-heading">Submit Content</h4>
        <ul>
          <li>
            <NavLink to={Routes.yourEvents()} className="link" onClick={onLinkClick}>
              <IconGlyph name="calendar" color="red" />
              <span className="link-text"> Your Events</span>
            </NavLink>
          </li>
          <li>
            <NavLink to={Routes.yourPlaces()} className="link" onClick={onLinkClick}>
              <IconGlyph name="location" color="green" />
              <span className="link-text"> Your Places</span>
            </NavLink>
          </li>
          {renderYourStories()}
        </ul>
      </div>

      <div className="dash-nav-subgroup">
        <h4 className="dash-nav-heading">Business</h4>
        <ul>
          <li>
            <NavLink to={Routes.organizations()} className="link" onClick={onLinkClick}>
              <Hugeicon name="bank" size={16} style={{ marginRight: 4, verticalAlign: 'middle' }} />
              <span className="link-text"> Organizations</span>
              {currentUser?.pendingInvitationsCount > 0 && (
                <span className="badge dash-pendingItemsLink-countBadge">
                  {currentUser.pendingInvitationsCount}
                </span>
              )}
            </NavLink>
          </li>
          <li>
            <NavLink to={Routes.businessCalendarDashboard()} className="link" onClick={onLinkClick}>
              <Hugeicon name="calendar" size={16} style={{ marginRight: 4, verticalAlign: 'middle' }} />
              <span className="link-text"> Business Calendar</span>
            </NavLink>
          </li>
        </ul>
      </div>

      <div className="dash-nav-subgroup">
        <ul>
          <li>
            <LogoutLink>
              <IconGlyph name="logout" color="white" />
              <span className="link-text"> Log out</span>
            </LogoutLink>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default UserSidebar
